import { z } from "zod";

const TOAST_POSITION_OPTIONS = [
  "top-left",
  "top-center",
  "top-right",
  "bottom-left",
  "bottom-center",
  "bottom-right",
] as const;

export const ToastPositionSchema = z.enum(TOAST_POSITION_OPTIONS);

// Returns undefined on invalid or malformed input so callers can apply their own fallback.
export function parseToastPosition(raw: string): z.infer<typeof ToastPositionSchema> | undefined {
  try {
    return ToastPositionSchema.safeParse(JSON.parse(raw)).data;
  } catch {
    return undefined;
  }
}

export const TOAST_POSITION_SELECT_DATA = TOAST_POSITION_OPTIONS.map((position) => ({
  label: position
    .split("-")
    .map((word) => (word[0]?.toUpperCase() ?? "") + word.slice(1))
    .join(" "),
  value: position,
}));
